import { render, staticRenderFns } from "./StoriesNewsFilters.vue?vue&type=template&id=21e8be80"
import script from "./StoriesNewsFilters.vue?vue&type=script&lang=js"
export * from "./StoriesNewsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports